<template>
  <div class="compressed-content">
    <h3 class="page-question">Do you have any of the following conditions? <br /> <i>(check all that apply)</i></h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.conditions">
      <b-form-checkbox v-model="survey.medicalConditions.conditions.hasNone" @change="onNoConditionSelected">
        None
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.medicalConditions.conditions.hasCHF" @change="onCHFSelected">
        Congestive heart failure (CHF)
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.medicalConditions.conditions.hasAFIB" @change="onAFIBSelected">
        Atrial fibrillation or “afib”
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.medicalConditions.conditions.hasFattyLiver" @change="onFattyLiverSelected">
        Non-alcoholic fatty liver disease
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.medicalConditions.conditions.hasAorticAneurysm" @change="onAorticAneurysmSelected">
        Aortic aneurysm
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      conditions: {
        anyOptionRequired: anyOptionRequired((value) => value.hasNone || value.hasCHF || value.hasAFIB
          || value.hasFattyLiver || value.hasAorticAneurysm)
      }
    },

    computed: {
      ...mapState(["survey"]),

      conditions() { return this.survey.medicalConditions.conditions; }
    },

    methods: {
      onNoConditionSelected(value) {
        this.setOptions(value, false, false, false, false);
      },

      onCHFSelected(value) {
        this.setOptions(false, value, this.conditions.hasAFIB, this.conditions.hasFattyLiver, this.conditions.hasAorticAneurysm);
      },

      onAFIBSelected(value) {
        this.setOptions(false, this.conditions.hasCHF, value, this.conditions.hasFattyLiver, this.conditions.hasAorticAneurysm);
      },

      onFattyLiverSelected(value) {
        this.setOptions(false, this.conditions.hasCHF, this.conditions.hasAFIB, value, this.conditions.hasAorticAneurysm);
      },

      onAorticAneurysmSelected(value) {
        this.setOptions(false, this.conditions.hasCHF, this.conditions.hasAFIB, this.conditions.hasFattyLiver, value);
      },

      setOptions(hasNone, hasCHF, hasAFIB, hasFattyLiver, hasAorticAneurysm) {
        this.survey.medicalConditions.conditions.hasNone = hasNone;
        this.survey.medicalConditions.conditions.hasCHF = hasCHF;
        this.survey.medicalConditions.conditions.hasAFIB = hasAFIB;
        this.survey.medicalConditions.conditions.hasFattyLiver = hasFattyLiver;
        this.survey.medicalConditions.conditions.hasAorticAneurysm = hasAorticAneurysm;
      }
    }
  };
</script>